<template>
  <modal-template
    ref="modal"
    class-header="d-none"
    title="Confirmar aprovação de orçamento"
    type-modal="approved_admin_quotation_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="send()">

        <d-form-row>
          <!-- Message -->
          <d-col md="12">
            <p>Tem certeza que deseja aprovar esse orçamento?</p>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control">
      <d-button type="button" @click="close()" class="btn btn-sm btn-secondary mr-3">Cancelar</d-button>
      <d-button type="button" @click="save()" class="btn btn-sm btn-primary">Confirmar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';
import QuotationService from '_services/rest/modules/quotation';
import Events from '_utils/events';
import { _OPEN_MODAL_, _LOAD_MODEL_, MODEL } from '../QuotationModel';

export default {
  name: 'approved_admin_quotation_modal',
  components: {
    ModalTemplate,
  },
  data() {
    return {
      quotation: { ...MODEL },
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'approved_admin_quotation_modal', bool: false });
    },
    save() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.approveAdminQuotation(this.quotation.id)
        .then(response => {
          this.setToggle({ type: 'approved_admin_quotation_modal', bool: false });
          this.activeAlert({ message: 'Orçamento aprovado com sucesso', theme: 'success' });
          Events.$emit(_LOAD_MODEL_, response);
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
    Events.$on(_OPEN_MODAL_, ({ quotation, type }) => {
      if (type === 'approved_admin_quotation_modal') {
        this.quotation = quotation;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
